import {
  Wrapper,
  Text,
  IconWrapper,
} from '@/ui/components/NothingFoundPlaceholder/NothingFoundPlaceholder.styles.ts'
import { useTranslation } from 'react-i18next'
import BugIcon from '@/core/assets/icons/bug.svg'

const NothingFoundPlaceholder = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Text>{t('nothingFoundPlaceholder.text')}</Text>
      <IconWrapper>
        <BugIcon />
      </IconWrapper>
    </Wrapper>
  )
}

export default NothingFoundPlaceholder
